import { Button, Grid, Typography } from "@mui/material";
import { MuiOtpInput } from "mui-one-time-password-input";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CustomButton from "../../../Components/CustomButton";
import Loader from "../../../Components/Loader";
import Fonts from "../../../Config/Fonts";
import Icons from "../../../Config/Images";
import Strings from "../../../Config/Strings";
import {
  resendUserOtpAPI,
  verifyUserOtpAPI,
} from "../../../Store/Action/authAction"; // Assume you have resendOtpAPI action
import { getLoggedInUserDetailsAPI } from "../../../Store/Action/UserAction";
import { login } from "../../../Store/Slice/authSlice";
import Colors from "../../../theme/Colors";
import "../Login/styles.css";
// import "../Login/LoginAdmin.css";

const OTPVerification = () => {
  const { handleSubmit } = useForm();
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(30); // 30 seconds timer
  const [timerRunning, setTimerRunning] = useState(true);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { userData } = useSelector((state) => state.user);

  useEffect(() => {
    let interval = null;
    if (timerRunning) {
      interval = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            setTimerRunning(false);
            setButtonDisabled(false); // Enable the button when time expires
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } else if (!timerRunning && timer !== 30) {
      setTimer(30); // Reset timer if not running
    }
    return () => clearInterval(interval);
  }, [timer, timerRunning]);

  const handleChange = (newValue) => {
    setOtp(newValue);
  };

  const onSubmit = async () => {
    const userRequestData = {
      authentication_code: otp.toString(),
    };
    try {
      await dispatch(
        verifyUserOtpAPI(userRequestData, (isSuccess, response) => {
          if (isSuccess?.status === true) {
            dispatch(getLoggedInUserDetailsAPI({}));
            toast.success(response?.data?.message);
            dispatch(login(response?.data?.user_details));
            // Redirect based on the user role
            if (userData?.data?.[0]?.user_role_name === Strings.Admin) {
             

              navigate("/admin/dashboard");
            }else if(userData?.data?.[0]?.user_role_name === "manufacturer"){
              navigate("/admin/dashboard");
            } else {
              
              alert("You are not an admin")
              // navigate("/userList");
            }
          } else {
            const errorMessage =
              response?.error?.message || Strings.somethingWentWrongError;
            toast.error(errorMessage);
          }
        })
      );
    } catch (error) {
      console.log("Error dispatching verifyUserOtpAPI:", error);
      setLoading(false);
      toast.error(Strings.somethingWentWrongError);
    }
  };

  const resendOtp = async () => {
    setResendLoading(true);
    try {
      await dispatch(
        resendUserOtpAPI((isSuccess, response) => {
          // Assuming resendOtpAPI exists
          setResendLoading(false);
          if (isSuccess?.status === true) {
            toast.success("OTP resent successfully.");
            setTimer(30); // Reset timer to 30 seconds
            setTimerRunning(true); // Restart the timer
            setButtonDisabled(true); // Disable the resend button
          } else {
            const errorMessage =
              response?.error?.message || Strings.somethingWentWrongError;
            toast.error(errorMessage);
          }
        })
      );
    } catch (error) {
      console.log("Error dispatching resendOtpAPI:", error);
      setResendLoading(false);
      toast.error(Strings.somethingWentWrongError);
    }
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? `0${secs}` : secs}`;
  };

  return (
    <div className="container">
      <div className="forms-container">
        <div style={rightSideView}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Typography style={mainHeadingStyle}>OTP Verification</Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography style={labelInfoStyle}>Enter OTP</Typography>
                <MuiOtpInput
                  value={otp}
                  onChange={handleChange}
                  length={6}
                  onComplete={handleChange}
                  autoFocus
                />
              </Grid>

              <Grid item xs={12}>
                {timerRunning ? (
                  <Typography style={timerStyle}>
                    Resend OTP in {formatTime(timer)}
                  </Typography>
                ) : (
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={resendOtp}
                    disabled={buttonDisabled || resendLoading}
                    style={resendButtonStyle}
                  >
                    {resendLoading ? "Resending..." : "Resend OTP"}
                  </Button>
                )}
              </Grid>

              <CustomButton
                handleSubmit={handleSubmit(onSubmit)}
                label={Strings.Submit}
              />
            </Grid>
          </form>
        </div>
      </div>

      <div className="panels-container">
        <div className="panel left-panel">
          <div className="content">
            <img
              src={Icons.loginCircle}
              style={{ height: "25vh", width: "13vw", marginBottom: "20px" }}
              alt="login circle icon"
            />
            <h3>New here?</h3>
            <p>
              Not a member yet? Join our community to receive exclusive offers,
              updates, and access to our latest collections!
            </p>
          </div>
        </div>
      </div>

      <Loader loading={loading} />
    </div>
  );
};

// Styles remain the same
const mainHeadingStyle = {
  fontSize: 24,
  fontWeight: "700",
  fontFamily: Fonts.NunitoSans,
  color: Colors.black,
  marginTop: "20px",
  marginBottom: "20px",
  width: "100%",
  display: "flex",
};

const labelInfoStyle = {
  fontSize: 14,
  fontWeight: "400",
  fontFamily: Fonts.NunitoSans,
  color: Colors.black,
  display: "flex",
  marginBottom: "5px",
};

const timerStyle = {
  fontSize: 14,
  fontWeight: "400",
  fontFamily: Fonts.NunitoSans,
  color: Colors.red, // or any color indicating a warning or notice
  display: "flex",
  marginTop: "10px",
};

const resendButtonStyle = {
  backgroundColor: Colors.white,
  color: Colors.black,
  borderRadius: "8px",
  border: "2px solid #ffff",
  fontSize: 14,
  fontWeight: "700",
  fontFamily: Fonts.NunitoSans,
  marginTop: "10px",
  "&:hover": {
    backgroundColor: Colors.black,
    color: Colors.white,
    border: "0px",
  },
  transition: "background-color 0.3s, color 0.3s",
};

const rightSideView = {
  position: "absolute",
  top: "50%",
  transform: "translate(-50%, -50%)",
  left: "75%",
  width: "50%",
  transition: "1s 0.7s ease-in-out",
  display: "flex",
  zIndex: 5,
};

export default OTPVerification;
